export default "__VITE_ASSET__2262a0b6__"